import React, { useEffect } from "react";
import {
  getCustomerUserLogs,
  getCustomerUsers,
} from "../../redux/actions/CustomerAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Autocomplete,
  Button,
  DialogActions,
  TextField,
  Typography,
} from "@mui/material";
import "../../CSS/CustomerLogs.css";

export default function CustomerLogs() {
  const dispatch = useDispatch();
  const [cust_user_id, setCust_user_id] = React.useState("");
  const [selectedUser, setSelectedUser] = React.useState("");
  const [rows, setRows] = React.useState([]);

  const cust_login_id = JSON.parse(localStorage.getItem("customer_login_id"));

  const GetCustomerUsers = useSelector((state) => state.GetCustomerUsers);
  const { customerUsersInfo, loading, error } = GetCustomerUsers;

  const GetCustomerUserLogs = useSelector((state) => state.GetCustomerUserLogs);
  const {
    customerUserLogsInfo,
    loading: logsLoading,
    error: logsError,
  } = GetCustomerUserLogs;

  useEffect(() => {
    dispatch(getCustomerUsers(cust_login_id));
    dispatch(getCustomerUserLogs(cust_login_id));
  }, [dispatch, cust_login_id]);

  useEffect(() => {
    if (customerUserLogsInfo) {
      const filteredLogs = customerUserLogsInfo.filter(
        (log) => log.changed_by_id === cust_user_id
      );
      setRows(filteredLogs);
    }
  }, [customerUserLogsInfo, cust_user_id]);

  const handleUserChange = (event, value) => {
    if (value) {
      setCust_user_id(value[0]?.cust_user_id);
      setSelectedUser(value[0]?.username);
    }
  };

  return (
    <div className="wrap-mu">
      <div className="container">
        <div style={{ padding: "20px" }}>
          <div className="log-title">
            <h2>View Users Logs</h2>
          </div>
          <div className="container-feld">
            <div className="autocomplete-select-customer-field">
              <Autocomplete
                className="autocomplete-select-customer"
                size="medium"
                multiple
                options={customerUsersInfo || []}
                getOptionLabel={(option) => `${option.username.trim()}`}
                value={[]}
                filterOptions={(options, { inputValue }) =>
                  options.filter((option) =>
                    `${option.username.trim()}`
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  )
                }
                renderInput={(params) => {
                  return (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select Users"
                      fullWidth
                    />
                  );
                }}
                onChange={handleUserChange}
              />
            </div>
          </div>

          <div className="container-feld" style={{ marginTop: "15px" }}>
            <Typography style={{ fontSize: "16px" }}>
              {selectedUser
                ? `Showing logs for ${selectedUser}`
                : "Select a user to view logs"}
            </Typography>
          </div>

          <div className="dt-mu-wrap">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={{ width: "10%" }}>Log ID</th>
                  <th style={{ width: "10%" }}>Action</th>
                  <th style={{ width: "10%" }}>Changed by</th>
                  <th style={{ width: "10%" }}>Changed Date/Time</th>
                  <th style={{ width: "30%" }}>Description</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((log) => (
                  <tr key={log.log_id}>
                    <td style={{ width: "10%" }}>{log.log_id}</td>
                    <td style={{ width: "10%" }}>
                      {log.operation
                        .trim()
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, (char) => char.toUpperCase())}
                    </td>
                    <td style={{ width: "10%" }}>{log.changed_by_name}</td>
                    <td style={{ width: "10%" }}>{log.changed_at}</td>
                    <td style={{ width: "30%" }}>
                      {log.description.split("\n").map((line, index) => (
                        <div key={index}>{line}</div>
                      ))}
                    </td>
                  </tr>
                ))}
                {rows.length === 0 && (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      {cust_user_id ? "No logs available." : "Select User"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
